

export const servicesData = {
  number: "03",
  name: "Services",
  heading: "Ce que nous proposons",
  description:
    "De la gestion de locations saisonnières jusqu'aux réservations de restaurants et événements en passant par l'assistance personnalisée pour particuliers et entreprises",
  data: [
    {
      id: 1,
      image: "/images/home/services/repas.jpg",
      heading: "Conciergerie privée",
      descp:
        "Profitez d’un quotidien sans contraintes grâce à nos services personnalisés : réservations de restaurants étoilés, organisation de voyages sur mesure, coordination d’événements privés ou gestion de vos tâches administratives. Nous faisons de vos envies une réalité.",
    },
    {
      id: 2,
      image: "/images/home/services/gestion.jpg",
      heading: "Conciergerie immobilière",
      descp:
        "Propriétaires, confiez-nous la gestion de vos biens. De l’accueil des locataires au ménage professionnel, en passant par l’entretien et la maintenance, nous assurons une gestion fluide et sans stress pour vos locations saisonnières ou résidences secondaires.",
    },
    {
      id: 3,
      image: "/images/home/services/seminaire.jpg",
      heading: "Services aux entreprises",
      descp:
        "Optimisez vos déplacements professionnels et événements d’entreprise. Nous organisons vos séminaires, réservons vos vols et hôtels, et accueillons vos invités VIP avec un service irréprochable.",
    },
  ],
};

export const teamData = {
  number: "06",
  data: [
    {
      image: "/images/home/team/team-img-1.png",
      name: "Martha Finley",
      position: "Creative Director",
      socialLinks: [
        { icon: "/images/socialIcon/twitter.svg", link: "https://twitter.com" },
        { icon: "/images/socialIcon/Be.svg", link: "https://www.behance.net/" },
        {
          icon: "/images/socialIcon/linkedin.svg",
          link: "https://linkedin.com",
        },
      ],
    },
    {
      image: "/images/home/team/team-img-2.png",
      name: "Floyd Miles",
      position: "Marketing Strategist",
      socialLinks: [
        { icon: "/images/socialIcon/twitter.svg", link: "https://twitter.com" },
        { icon: "/images/socialIcon/Be.svg", link: "https://www.behance.net/" },
        {
          icon: "/images/socialIcon/linkedin.svg",
          link: "https://linkedin.com",
        },
      ],
    },
    {
      image: "/images/home/team/team-img-3.png",
      name: "Glenna Snyder",
      position: "Lead Designer",
      socialLinks: [
        { icon: "/images/socialIcon/twitter.svg", link: "https://twitter.com" },
        { icon: "/images/socialIcon/Be.svg", link: "https://www.behance.net/" },
        {
          icon: "/images/socialIcon/linkedin.svg",
          link: "https://linkedin.com",
        },
      ],
    },
    {
      image: "/images/home/team/team-img-4.png",
      name: "Albert Flores",
      position: "UX/UI Developer",
      socialLinks: [
        { icon: "/images/socialIcon/twitter.svg", link: "https://twitter.com" },
        { icon: "/images/socialIcon/Be.svg", link: "https://www.behance.net/" },
        {
          icon: "/images/socialIcon/linkedin.svg",
          link: "https://linkedin.com",
        },
      ],
    },
  ],
};

export const faqData = {
  data: [
    {
      faq_que: "What services does your agency offer?",
      faq_ans:
        "Yes, we provide post-launch support to ensure smooth implementation and offer ongoing maintenance packages for clients needing regular updates or technical assistance.",
    },
    {
      faq_que: "How long does a typical project take?",
      faq_ans:
        "Yes, we provide post-launch support to ensure smooth implementation and offer ongoing maintenance packages for clients needing regular updates or technical assistance.",
    },
    {
      faq_que: "Do you offer custom designs, or do you use templates?",
      faq_ans:
        "Yes, we provide post-launch support to ensure smooth implementation and offer ongoing maintenance packages for clients needing regular updates or technical assistance.",
    },
    {
      faq_que: "What’s the cost of a project?",
      faq_ans:
        "Yes, we provide post-launch support to ensure smooth implementation and offer ongoing maintenance packages for clients needing regular updates or technical assistance.",
    },
    {
      faq_que: "Do you provide ongoing support after project completion?",
      faq_ans:
        "Yes, we provide post-launch support to ensure smooth implementation and offer ongoing maintenance packages for clients needing regular updates or technical assistance.",
    },
  ],
};

export const contactData = {
  keypoint: ["Always-On Customer Support", "Service Across the Globe"],
  managerProfile: {
    image: "/images/avatar/avatar_1.jpg",
    name: "Courtney Henry",
    position: "Onboarding & Success Manager",
  },
};

export const aboutusStats = [
  {
    number: 45,
    postfix: "+",
    title: "Presence in global markets",
    descp:
      "Expanding reach across international regions with localized expertise and worldwide impact.",
  },
  {
    number: 15,
    prefix: "$",
    postfix: "M",
    title: "In strategic investments",
    descp:
      "Driving growth with curated partnerships and high-performing, audience-driven initiatives.",
  },
  {
    number: 158,
    postfix: "+",
    title: "Trusted brand collaborations",
    descp:
      "Shaping industry conversations through innovation, creativity, and lasting influence.",
  },
];

export const servicesSliderData = [
  "Branding",
  "Web development",
  "Agency",
  "Content creation",
  "SaaS",
  "Motion & 3d modeling",
  "Photography",
];
